<template>
  <div class="resource">
    <!-- 确认提示框 -->
    <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="30%">
      <span>此时需要先登录才能继续操作哦</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goLogin">去登录</el-button>
      </span>
    </el-dialog>

    <div class="progress-container" v-if="progress > 0">
      <div class="progress-bar" :style="{ width: progress + '%' }">
        <span>{{ progress }}%</span>
      </div>
    </div>
    <div class="type-btn">
      <button
        :class="{ selected: type === 20 }"
        @click="selectType(20)"
      >
        毕业设计
      </button>
      <button
        :class="{ selected: type === 10 }"
        @click="selectType(10)"
      >
        手抄报
      </button>
    </div>
    <div class="search-box">
      <input
        class="search-inp"
        type="text"
        v-model="searchValue"
        placeholder="请输入搜索关键词"
        @keyup.enter="handleSearch"
      />
      <button @click="handleSearch" class="search-btn">搜索</button>
      <span v-if="type === 10">
          <span class="search-label" @click="handleSearchLabel('元旦')">元旦</span>
          <span class="search-label" @click="handleSearchLabel('国庆')">国庆</span>
          <span class="search-label" @click="handleSearchLabel('中秋')">中秋</span>
          <span class="search-label" @click="handleSearchLabel('元宵')">元宵</span>
          <span class="search-label" @click="handleSearchLabel('寒假')">寒假</span>
          <span class="search-label" @click="handleSearchLabel('春节')">春节</span>
          <span class="search-label" @click="handleSearchLabel('通用')">通用</span>
          <span class="search-label" @click="handleSearchLabel('A3')">A3</span>
          <span class="search-label" @click="handleSearchLabel('A4')">A4</span>
      </span>
      <span v-if="type === 20">
          <span class="search-label" @click="handleSearchLabel('Andorid')">Andorid</span>
          <span class="search-label" @click="handleSearchLabel('C语言')">C语言</span>
          <span class="search-label" @click="handleSearchLabel('java swing')">java swing</span>
          <span class="search-label" @click="handleSearchLabel('Java web')">Java web</span>
          <span class="search-label" @click="handleSearchLabel('计算机专业-JSP')">计算机专业-JSP</span>
          <span class="search-label" @click="handleSearchLabel('计算机专业-VB')">计算机专业-VB</span>
      </span>

    </div>
    <div class="flexBlock">
      <div v-for="item in list" :key="item.id" class="api-item">
        <div class="download-count">下载量：{{ item.downloadCount }}</div>

        <img
          class="api-item-image"
          :src="item.url"
          :alt="item.name"
          :title="item.fullName + '/' + item.lengthStr"
        />
        <p class="api-item-name">{{ item.fullName }}</p>
        <div class="api-item-desc">
          {{ item.remark }}
        </div>

        <div v-if="!item.payFlag" class="api-item-price">
          ¥{{ item.priceStr }}
        </div>

        <button
          class="api-item-btn api-item-btn-download"
          v-if="item.payFlag"
          @click="(e) => goDownload(e, item.id, item.name)"
        >
          去下载
        </button>
        <button class="api-item-btn" v-else @click="goPay(item.id)">
          去购买
        </button>
      </div>
    </div>

    <div class="qrCode">
      <el-dialog
        title="支付二维码"
        :visible.sync="showDialog"
        width="40%"
        custom-class="custom-dialog"
        @close="closeDialog"
      >
        <div class="qr-code-container">
          <img :src="qrCodeUrl" alt="支付二维码" v-if="qrCodeUrl" />
          <p>
            请使用<span style="color: red; font-weight: 700">"微信"</span
            >扫描二维码完成支付
          </p>
        </div>
        <span slot="footer" class="dialog-footer"> </span>
      </el-dialog>
    </div>

    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[12, 24, 48]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getOtherResourcePage, goOtherResourcePay } from '@/api/resource'
import { mapGetters } from 'vuex'

import QRCode from 'qrcode'
import { getByOrderNo } from '@/api/pay'
import axios from 'axios'
export default {
  data () {
    return {
      size: 12,
      current: 1,
      totalCount: 0,
      progress: 0,
      dialogVisible: false,
      list: [],
      qrCodeUrl: null,
      showDialog: false,
      timerId: null,
      searchValue: '',
      type: 20
    }
  },
  methods: {
    closeDialog () {
      if (this.timerId) {
        console.log('关闭定时器：' + this.timerId)
        clearInterval(this.timerId)
      }
    },
    goLogin () {
      this.dialogVisible = false
      this.$router.replace({
        path: '/login',
        query: {
          backUrl: this.$route.fullPath
        }
      })
    },
    async goPay (id) {
      const token = this.$store.getters.token
      // 未登录
      if (!token) {
        this.dialogVisible = true
        return
      }
      // 调用获取方法
      const result = await goOtherResourcePay(id)
      try {
        const url = await QRCode.toDataURL(result.data.codeUrl)
        this.qrCodeUrl = url
      } catch (err) {
        console.error('生成二维码失败:', err)
        return
      }
      this.showDialog = true

      // 开启定时器轮询查订单状态，若支付成功则关闭弹层，跳转到页面
      this.timerId = setInterval(async () => {
        const orderObj = await getByOrderNo(result.data.orderNo)
        if (orderObj && orderObj.data && orderObj.data.orderStatus === 60) {
          this.showDialog = false
          clearInterval(this.timerId)
          this.$router.go(0)
          this.$toast.success('支付成功')
        }
      }, 2000)
    },
    async goDownload (event, id, name) {
      const token = this.$store.getters.token
      // 未登录
      if (!token) {
        this.dialogVisible = true
        return
      }
      event.target.disabled = true
      event.target.classList.add('api-item-btn-download-disabled')

      try {
        this.$toast.loading({
          message: '下载中，请勿离开此页面...',
          forbidClick: true, // 禁止背景点击
          duration: 0, // 时长，不会自动消失
          loadingType: 'spinner' // 图标
        })
        const response = await axios({
          url: 'https://data.isbn.work/otherResource/download/' + id,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token
          },
          responseType: 'blob', // 重要：设置响应类型为blob
          onDownloadProgress: (progressEvent) => {
            this.progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
          }
        })

        // 处理下载文件
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name) // 设置下载文件名
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        event.target.disabled = false
        event.target.classList.remove('api-item-btn-download-disabled')

        this.$toast.success('下载成功')
      } catch (error) {
        this.$toast.fail('下载发生错误，请联系管理员')
      } finally {
        this.progress = 0
      }
    },
    async handleSizeChange (val) {
      this.size = val
      this.handleSearch()
    },
    async handleSearch () {
      const result = await getOtherResourcePage(
        this.getUserId,
        this.searchValue,
        this.type,
        this.current,
        this.size
      )
      this.list = result.data.records
      this.totalCount = +result.data.total
    },
    async handleSearchLabel (label) {
      this.searchValue = label
      this.handleSearch()
    },
    async handleCurrentChange (val) {
      this.current = val
      this.handleSearch()
    },
    selectType (type) {
      this.type = type
      this.handleSearch()
    }
  },
  async created () {
    this.handleSearch()
  },
  computed: {
    ...mapGetters(['getUserId'])
  },
  destroyed () {
    if (this.timerId) {
      console.log('关闭定时器：' + this.timerId)
      clearInterval(this.timerId)
    }
  }
}
</script>

<style lang="less" scoped>
.resource {
  margin: 0 auto;
  width: 1000px;
  .type-btn {
    margin: 10px 0 10px 10px;
    button {
      margin-right: 15px;
      padding: 6px 16px;
      border: 1px solid #e0e0e0;
      cursor: pointer;
      border-radius: 16px;
      font-size: 13px;
      color: #606266;
      background-color: #fff;
      transition: all 0.3s ease;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);
        color: #2c3e50;
      }

      &.selected {
        background: linear-gradient(135deg, #67C23A, #85CE61);
        color: white;
        border: none;
        font-weight: 400;
      }
    }
  }
  h1 {
    padding: 10px 10px 10px;
  }
  .block {
    text-align: center;
  }
  .tips {
    color: orangered;
    font-size: 12px;
    margin: 0 10px 10px 10px;
  }
  .search-box {
    margin: 10px 0 10px 10px;
    .search-inp {
      border: 1px solid #999;
      border-radius: 3px;
    }
    .search-btn {
      font-size: 13px;
      padding: 0 5px;
      margin-left: 15px;
    }
    .search-label {
      color: rgb(209, 121, 121);
      font-size: 12px;
      font-weight: 700;
      padding: 0 5px;
      margin-left: 8px;
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .flexBlock {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .api-item {
      width: 232px;
      height: 260px;
      border: 1px solid #eee;
      border-radius: 5px;
      margin: 0 9px 22px;
      text-align: center;
      padding-top: 20px;
      position: relative;
      box-shadow: 0 3px 10px 0 hsla(0, 0%, 60.8%, 0.16);
      .download-count {
        font-size: 12px;
        color: #fff;
        width: 80px;
        height: 20px;
        padding: 2px 2px;
        position: absolute;
        top: 10px;
        right: -9px;
        background-color: rgb(240, 161, 132);
        border-radius: 5px;
      }
      .api-item-image {
        width: 180px;
        height: 135px;
        object-fit: contain;
      }
      .api-item-price {
        position: absolute;
        bottom: 42px;
        left: 0;
        right: 0;
        margin: 0 auto;
        color: #ff5441;
        font-size: 16px;
        font-weight: 600;
      }
      .api-item-original-price {
        left: 0;
        right: 0;
        margin: 0 auto;
        position: absolute;
        bottom: 75px;
        color: #9b9696;
        font-size: 13px;
        width: 75px;
      }
      .api-item-original-price::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        right: 0; /* 从左到右占据整个容器宽度 */
        height: 1px; /* 删除线的高度 */
        background-color: #9b9696; /* 删除线的颜色 */
        transform: translateY(-50%); /* 垂直居中 */
      }
      .api-item-name {
        color: #666;
        font-size: 12px;
        font-weight: 700;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .api-item-desc {
        padding: 8px 14px 0;
        font-size: 12px;
        color: #999;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
      .api-item-btn {
        position: absolute;
        left: 10%;
        bottom: 15px;
        width: 80%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background-color: #00bdff;
        border-radius: 6px;
        cursor: pointer;
        color: #fff;
        border: none;
      }
      .api-item-btn-download {
        background-color: burlywood;
      }
      .api-item-btn-download-disabled {
        background-color: rgb(182, 180, 178);
      }
    }
  }
  .progress-container {
    width: 100%;
    background-color: #f3f3f3;
    border-radius: 5px;
    overflow: hidden;
    margin: 20px 0;
    height: 20px;
    .progress-bar {
      position: relative;
      height: 100%;
      width: 0;
      background-color: #4caf50;
      transition: width 0.5s ease-in-out;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      box-sizing: border-box;
      span {
        position: absolute;
        right: 5px;
        color: white;
        font-size: 14px;
      }
    }
  }
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .resource {
    width: 100%;
    padding: 12px;

    .type-btn {
      margin: 10px 0;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      button {
        margin: 0;
        padding: 6px 12px;
        font-size: 12px;
      }
    }

    .search-box {
      margin: 10px 0;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      align-items: center;

      .search-inp {
        width: 100%;
        height: 32px;
        font-size: 13px;
      }

      .search-btn {
        margin-left: 0;
        padding: 0 12px;
        height: 32px;
        font-size: 12px;
      }

      .search-label {
        margin-left: 5px;
        font-size: 11px;
      }
    }

    .block {
      .el-pagination {
        font-size: 12px;
      }
    }

    .flexBlock {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 6px;

      .api-item {
        width: calc(50% - 12px);
        min-height: 200px;
        margin: 0 6px 16px;
        padding-top: 12px;

        .download-count {
          font-size: 10px;
          width: 60px;
          height: 16px;
          top: 6px;
          right: -6px;
        }

        .api-item-image {
          width: 100px;
          height: 80px;
        }

        .api-item-name {
          font-size: 11px;
        }

        .api-item-desc {
          font-size: 10px;
          padding: 5px 8px 0;
          -webkit-line-clamp: 2;
        }

        .api-item-price {
          font-size: 14px;
          bottom: 40px;
        }

        .api-item-btn {
          height: 26px;
          line-height: 26px;
          bottom: 10px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
